module.exports = __webpack_public_path__ + "img/627D72_A6CAAA_202C28_B4D4B4-256px.704e5d77.png";